import { apolloClient } from "../../../vue-apollo";
import { exMut } from "@/utils/gql";

import {
  EDITAR_ESTADO_SOLICITUD_HOTELERIA,
  SEND_MENSAJES_SOLICITUD,
  CREATE_AMONESTACIONES_HOTELERIA,
  EDIT_AMONESTACIONES_HOTELERIA,
  DELETE_AMONESTACIONES_HOTELERIA,
} from "@/apollo/mutations";

import {
  GET_DASHBOARD_HOTELERIA,
  GET_SOLICITUDES_ADMIN_PAGINADO,
  GET_URGENCIA_SOLICITUD,
  GET_CLOSET_UBICACION,
  GET_CAMA_UBICACION,
  GET_CALIFICACION_HOTELERIA,
  GET_SERVICIOS_HOTELERIA,
  GET_DETALLES_SERVICIOS_HOTELERIA,
  GET_ALL_SOLICITUD_USUARIO,
  TOTAL_SOLICITUDES_USUARIO,
  LIMITE_ALL_SOLICITUDES_USUARIO,
  GET_SOLICITUD_USUARIO_INDIVIDUAL,
  GET_AMONESTACIONES_ID,
  GET_AMONESTACIONES_PAGINACION_HOTELERIA_ADMIN,
  GET_AMONESTACIONES_LISTA_ID,
  GET_ESTADO_SOLICITUD_BY_EMPRESA,
  GET_SOLICITUDES_ADMIN_EXCEL,
  GET_USUARIOS,
} from "@/apollo/queries";

export default {
  namespaced: true,
  state: {
    solicitudesListPaginado: [],
    solicitudesListPaginadoHash:{},
    serviciosHoteleria: [],
    estadosHoteleria: [],
    paginaData:{},

    amonestacionesPagination: [],
    amonestacionesDataTable: [],
    amonestacionesFilters: {
      nombreUsuario: "",
      fechaIni: "",
      fechaFin: "",
      limite: "12",
    },
    hoteleriaUsers: [],
  },

  mutations: {
    setSolicitudesListPaginado(state, data) {
      state.solicitudesListPaginadoHash = {}
      state.solicitudesListPaginado = []
      data.forEach(el => {
        state.solicitudesListPaginadoHash[el.id_solicitud] = true
        state.solicitudesListPaginado.push(el)
      });
    },
    setSolicitudesList(state, data) {
      data.forEach(el => {
        if(state.solicitudesListPaginadoHash[el.id_solicitud] === undefined){
          state.solicitudesListPaginado.push(el)
          state.solicitudesListPaginadoHash[el.id_solicitud] = true
        }
      })
    },
    setSolicitudChangeState(state, data) {
      let solicitud = state.solicitudesListPaginado.findIndex(({id_solicitud})=> id_solicitud === data.id_solicitud)
      if(solicitud >= 0){
        state.solicitudesListPaginado[solicitud] = data
      } 
    },
    setServiciosHoteleriaLista(state, data) {
      state.serviciosHoteleria = data;
    },
    setEstadosSolicitudes(state, data) {
      state.estadosHoteleria = data;
    },
    setPagina(state, data) {
      state.paginaData =
        data || {
          previous_page: "0",
          next_page: "0",
          count: "0",
          total_pages: "0",
          data: [],
        };
    },
    updateSolicitudMessages(state, { idSolicitud, mensajes }) {
      const solicitud = state.solicitudesListPaginado.find(
        (s) => s.id_solicitud === idSolicitud
      );
      if (solicitud) {
        solicitud.mensajes = mensajes;
      }
    },
    setAmonestacionesPagination(state, data) {
      state.amonestacionesPagination = data || [];
    },
    setAmonestacionesDataTable(state, data) {
      state.amonestacionesDataTable = data || [];
    },
    setAmonestacionesFilters(state, filters) {
      state.amonestacionesFilters = {
        ...state.amonestacionesFilters,
        ...filters,
      };
    },
    setHoteleriaUsers(state, data) {
      state.hoteleriaUsers = data || [];
    },
  },

  actions: {
    async getDataHoteleria(_, data) {
      const params = {
        query: GET_DASHBOARD_HOTELERIA,
        variables: data,
      };
      let response = null;
      try {
        let hoteleriaData = null;
        response = await apolloClient.query(params);
        if (!response.loading) hoteleriaData = response.data.DashboardHoteleria;
        response = hoteleriaData;
      } catch (e) {
        console.error(e.networkError?.result?.errors ?? e);
      }
      return response;
    },
    async getSolicitudesAdminPaginado({ commit }, data) {
      const params = {
        query: GET_SOLICITUDES_ADMIN_PAGINADO,
        variables: data,
        fetchPolicy: "network-only"
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.getListaSolicitudesAdminPaginado;
        if (!response) {
          commit("setPagina", null);
          if (data.pagina == 1) commit("setSolicitudesListPaginado", []);
          return null;
        }
        commit("setPagina", response);
        if(response && data.pagina == 1) commit("setSolicitudesListPaginado", response.data || []);
        if(response && data.pagina > 1) commit("setSolicitudesList", response.data || []);
      } catch (e) {
        console.error(e.networkError?.result?.errors ?? e);
      }

      return response;
    },
    async getSolicitudesAdminExcel(_, data) {
      const params = {
        query: GET_SOLICITUDES_ADMIN_EXCEL,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) data = response.data.solicitudesHoteleriaExcel;
        return data
      } catch (e) {
        console.error(e);
      }
    },

    async getEstadosSolicitud({ commit }, data) {
      const params = {
        query: GET_ESTADO_SOLICITUD_BY_EMPRESA,
        variables: data,
      };
      await apolloClient
        .query(params)
        .then((response) => {
          response.data.getEstadoByIdEmp && commit(
            "setEstadosSolicitudes",
            response.data.getEstadoByIdEmp.map(
              ({ color, id_estado, nombre_estado, __typename }) => ({
                color,
                id: Number(id_estado),
                label: nombre_estado,
                type: __typename,
              })
            )
          );
          response.data.getEstadoByIdEmp == null && commit("setEstadosSolicitudes", []);
        })
        .catch((e) => {
            console.error(e);
        });
    },

    async getServiciosHoteleria({ commit }, data) {
      const params = {
        query: GET_SERVICIOS_HOTELERIA,
        variables: data,
      };
      let response = null;
      try {
        response = await apolloClient.query(params);
        response && commit(
          "setServiciosHoteleriaLista",
          response.data.getServiciosIdEmp.map(
            ({
              id_servicio,
              nombre_servicio,
              descripcion_servicio,
              imagen_servicio,
              __typename,
            }) => ({
              id: Number(id_servicio),
              label: nombre_servicio,
              desc: descripcion_servicio,
              img: imagen_servicio,
              type: __typename,
            })
          )
        );
        !response && commit("setServiciosHoteleriaLista", []);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async senMesajeHoteleria({ commit }, data) {
      try {
        const response = await exMut(SEND_MENSAJES_SOLICITUD, data);
        
        // Update messages in state
        if (response && response.mensajes && response.id_solicitud) {
          commit("updateSolicitudMessages", {
            idSolicitud: response.id_solicitud,
            mensajes: response.mensajes,
          });
        }
        
        return response;
      } catch (e) {
        console.error("Error enviando mensaje de hotelería:", e);
        throw e;
      }
    },

    async getUrgenciaSolicitud(_, data) {
      const params = {
        query: GET_URGENCIA_SOLICITUD,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.getUrgenciaIdEmp;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async changeState({ commit }, data) {
      for (const i in data) {
          const element = data[i];
          const params = {
            mutation: EDITAR_ESTADO_SOLICITUD_HOTELERIA,
            variables: element,
          };
          let response = null;
          try {
            response = await apolloClient.mutate(params);

            response && commit("setSolicitudChangeState",response.data.UpdateEstadoSolicitudHoteleria)
          } catch (e) {
            console.error(e);
          }

      }
      
    },	
    async getClosetUbicacion(_, data) {
      const params = {
        query: GET_CLOSET_UBICACION,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.getClosetIdEmp;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getCamaUbicacion(_, data) {
      const params = {
        query: GET_CAMA_UBICACION,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.getCamaIdEmp;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getCalificacionHoteleria(_, data) {
      const params = {
        query: GET_CALIFICACION_HOTELERIA,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.getCalificacionIdEmp;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getDetallesServiciosHoteleria(_, data) {
      const params = {
        query: GET_DETALLES_SERVICIOS_HOTELERIA,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.getServicioDetalleIdEmp;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getSolicitudesUsuario(_, data) {
      const params = {
        query: GET_ALL_SOLICITUD_USUARIO,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading)
          response = response.data.getAllSolicitudesUsuario;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getTotalSolicitudesUsuario(_, data) {
      const params = {
        query: TOTAL_SOLICITUDES_USUARIO,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.totalSolicitudesUsuario;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async limiteSolicitudesUsuario(_, data) {
      const params = {
        query: LIMITE_ALL_SOLICITUDES_USUARIO,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading)
          data = response.data.getAllSolicitudesUsuarioLimit;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getSolicitudUsuario(_, data) {
      const params = {
        query: GET_SOLICITUD_USUARIO_INDIVIDUAL,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.getOneSolicitudUsuario;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getAmonestaciones(_, data) {
      const params = {
        query: GET_AMONESTACIONES_ID,
        variables: data,
      };
      let response = null;
      try {
        let data = null;
        response = await apolloClient.query(params);
        if (!response.loading) response = response.data.getAmonestaciones;
        response = data;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async getAmonestacionesPagination({ state, commit, dispatch }, filters = {}) {
      const mergedFilters = {
        ...state.amonestacionesFilters,
        ...filters,
      };
      commit("setAmonestacionesFilters", mergedFilters);

      const params = {
        query: GET_AMONESTACIONES_PAGINACION_HOTELERIA_ADMIN,
        variables: {
          nombreUsuario: mergedFilters.nombreUsuario || "",
          fechaIni: mergedFilters.fechaIni || "",
          fechaFin: mergedFilters.fechaFin || "",
          limite: mergedFilters.limite || "12",
        },
        fetchPolicy: "network-only",
      };

      try {
        const response = await apolloClient.query(params);
        const pagination = response?.data?.paginasAmonestacionesHoteleriaAdmin || [];
        commit("setAmonestacionesPagination", pagination);

        if (pagination.length > 0) {
          await dispatch("getAmonestacionesPage", {
            idEmpresa: mergedFilters.idEmpresa,
            ids: pagination[0].ids || [],
          });
        } else {
          commit("setAmonestacionesDataTable", []);
        }

        return pagination;
      } catch (e) {
        console.error(e);
        commit("setAmonestacionesPagination", []);
        commit("setAmonestacionesDataTable", []);
        return [];
      }
    },

    async getAmonestacionesPage({ commit }, data) {
      const ids = Array.isArray(data?.ids) ? data.ids.filter(Boolean) : [];
      if (ids.length === 0) {
        commit("setAmonestacionesDataTable", []);
        return [];
      }

      const params = {
        query: GET_AMONESTACIONES_LISTA_ID,
        variables: {
          idAmonestacion: ids.map((id) => String(id)),
        },
        fetchPolicy: "network-only",
      };

      try {
        const response = await apolloClient.query(params);
        const list = response?.data?.getAmonestacionesListaId || [];
        commit("setAmonestacionesDataTable", list);
        return list;
      } catch (e) {
        console.error(e);
        commit("setAmonestacionesDataTable", []);
        return [];
      }
    },

    async createAmonestacionHoteleria({ dispatch, state }, data) {
      const response = await exMut(CREATE_AMONESTACIONES_HOTELERIA, data);
      if (response) {
        await dispatch("getAmonestacionesPagination", state.amonestacionesFilters);
      }
      return response;
    },

    async editAmonestacionHoteleria({ dispatch, state }, data) {
      const response = await exMut(EDIT_AMONESTACIONES_HOTELERIA, data);
      if (response) {
        await dispatch("getAmonestacionesPagination", state.amonestacionesFilters);
      }
      return response;
    },

    async deleteAmonestacionHoteleria({ dispatch, state }, data) {
      const response = await exMut(DELETE_AMONESTACIONES_HOTELERIA, data);
      if (response) {
        await dispatch("getAmonestacionesPagination", state.amonestacionesFilters);
      }
      return response;
    },

    async getHoteleriaUsers({ commit }, data) {
      const params = {
        query: GET_USUARIOS,
        variables: {
          nombreUsuario: data.nombreUsuario || "",
        },
        fetchPolicy: "network-only",
      };

      try {
        const response = await apolloClient.query(params);
        const usersRaw = response?.data?.FindUserSolicitud || [];
        const usersHash = {};

        usersRaw.forEach((item) => {
          const user = item?.usuario;
          if (user?.id_usuario && !usersHash[user.id_usuario]) {
            usersHash[user.id_usuario] = {
              id: String(user.id_usuario),
              label: `${user.primer_nombre || ""} ${user.apellido_paterno || ""} ${user.apellido_materno || ""}`.trim(),
            };
          }
        });

        const users = Object.values(usersHash);
        commit("setHoteleriaUsers", users);
        return users;
      } catch (e) {
        console.error(e);
        commit("setHoteleriaUsers", []);
        return [];
      }
    },
  },
};
